<template>
  <div class="absolute right-0 top-0 m-1 flex flex-row gap-1">
    <button class="btn btn-primary btn-sm" @click="mainStore.goToPreviousStep()">Prev</button>
    <button class="btn btn-primary btn-sm" @click="mainStore.goToNextStep()">Next</button>
    <button class="btn btn-primary btn-sm" @click="submit()">Submit</button>
    <select id="step-selector" v-model="mainStore.step" class="rounded-full px-3 py-1">
      <option v-for="storeStep in STEPS" :key="storeStep" :value="storeStep">{{ storeStep }}</option>
    </select>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { STEPS, useMainStore } from '@/apps/fast/store'

export default {
  computed: {
    ...mapStores(useMainStore),
    STEPS() {
      return STEPS
    }
  },
  methods: {
    submit() {
      this.$root.createAndStoreProject()
    }
  }
}
</script>
